const translation = {
  tab2020: '2020年',
  tab2021: '2021年',
  title: "年末精算利用ガイド",
  subText: "WEHAGO年末調整サービスの機能をご確認ください！",
  download: "年末調整マニュアルダウンロード",
  enquiryRegistrationAlert: "年末調整の問い合わせが登録されました。",
  checkInfo1: "お問い合わせ者情報をご確認ください。",
  replyEmail: "Eメールアドレスで迅速にご回答いたします。",
  validationError: "連絡先やメールアドレスの形式が正しくありません。",
  checkInfo2: "情報を確認した後、もう一度実行してください。",
  ok: "確認",
  provideLater: "追って提供する予定です。",
  author: "作成者",
  enterName: "氏名を入力してください。",
  companyName: "会社名",
  enterCompanyName: "会社名を入力してください。",
  contacts: "連絡先",
  enterContacts: "連絡先を入力してください(' - '除く)",
  email: "Eメール",
  enterEmail: "メールアドレスを入力してください。",
  enquiryRegistration: "WEHAGO年末調整のお問い合わせ登録",
  enquirySubText:
    "の年末精算サービスについてご不明な点についてご記入ください。",
  InquirerInfo: "お問い合わせ者情報",
  InquirerContent: "お問い合わせ内容",
  enterContent: "内容を入力してください。",
  consentText: `情報通信網利用促進及び情報保護等に関する法律に基づき、年末調整サービスのお問い合わせを処理するために次の通り個人情報を収集及び利用しますので、同意してください。 <br/> <br/>
                収集項目:氏名、会社名、携帯電話、Eメールアドレス <br/> 
                収集目的:お問い合わせに対する回答回答回答 <br/> 
                保管期間:お問い合わせ登録日から3年まで保管利用後に破棄 `,
  registration: "登録",
  fullView: "全体を見る",
  folding: "折り紙",
  postDate: "掲示日",
  hitCount: "照会回数",
  faq: "よくある質問",
  inquiryRegistration1: "問い合わせ登録",
  inquiryRegistration2: "問い合わせ登録",
  subTitle: "WEHAGO 年末調整",

  webpacktest: "test ja",

  contentsPreparingTitle: "콘텐츠 준비중입니다.",
  contentsPreparingMessage: "빠른 시일내에 오픈하겠습니다.",
};

export { translation };
